export enum ActivityHistoryCount {
  One = 1,
  Three = 3,
  Five = 5,
  Ten = 10
}
